// @flow
import * as React from 'react'
import PropTypes from 'prop-types'
import { Link as ReactRouterLink, type LocationShape } from 'react-router-dom'
import uri from 'urijs'

import './Link.scss'

type Props = {
  href: string | LocationShape,
  blend: boolean,
  trapClicks: boolean,
  full: boolean,
  replace: boolean,
  native: boolean,
  target?: string,
  onFocus: () => void,
  onBlur: () => void,
  onClick: (event?: Event) => any,
  children: React.Node,
}

export default class Link extends React.Component<Props> {
  static defaultProps = {
    href: '#',
    blend: false,
    trapClicks: false,
    full: false,
    replace: false,
    native: false,
    onFocus: () => undefined,
    onBlur: () => undefined,
    onClick: () => undefined,
  }

  static contextTypes = {
    useReactRouterLink: PropTypes.bool,
  }

  render = () => {
    return this.shouldUseReactRouterLink ? this.renderReactRouterLink() : this.renderNativeLink()
  }

  renderReactRouterLink = () => {
    return (
      <ReactRouterLink
        className={this.className}
        to={this.props.href}
        target={this.props.target}
        replace={this.props.replace}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        onClick={this.handleClick}
      >
        {this.props.children}
      </ReactRouterLink>
    )
  }

  renderNativeLink = () => {
    return (
      <a
        className={this.className}
        href={this.props.href}
        target={this.props.target}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        onClick={this.handleClick}
      >
        {this.props.children}
      </a>
    )
  }

  handleClick = (event: Event) => {
    if (this.props.href === '#') event.preventDefault()
    if (this.props.trapClicks) event.stopPropagation()

    this.props.onClick(event)
  }

  get shouldUseReactRouterLink(): boolean {
    if (this.props.native) return false

    // react-router-dom/Link only works with paths, so if a protocol is detected, we must
    // use an <a> element
    return !!this.context.useReactRouterLink && uri(this.props.href).protocol() === ''
  }

  get className(): string {
    return [
      'Link',
      this.props.full ? 'Link--full' : '',
      this.props.blend ? 'Link--blend' : '',
    ].join(' ')
  }
}
